import { Divider, Flex, Table } from 'antd'
import { useState } from 'react'

import {
  usePersonsServiceGetPersonEndpoint,
  useQuestionnairesServiceGetQuestionnaireSharedListEndpoint
} from 'src/api/queries'
import { AnsweredState } from 'src/api/requests'
import { SearchBar, Select } from 'src/components'
import { useDefaultSortingItem, useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'
import { resetPagination } from 'src/utils'

import { useConfig } from './useConfig'

export const PatientQuestionnairesTable = () => {
  const { t } = useLocales()
  const pagination = useTablePagination()

  const [search, setSearch] = useState('')
  const [status, setStatus] = useState<AnsweredState>()

  const { columns } = useConfig()

  const { defaultSortingOption } = useDefaultSortingItem()

  const { data: personDetails, isLoading: isPersonLoading } =
    usePersonsServiceGetPersonEndpoint()

  const queryParams = {
    pageNumber: Number(pagination.current),
    pageSize: Number(pagination.pageSize),
    personId: String(personDetails?.id),
    ...(!!search && {
      searchTerm: search
    }),
    sharedOnly: true,
    ...(!!status && {
      answered: [status]
    })
  }

  const { data, isLoading } =
    useQuestionnairesServiceGetQuestionnaireSharedListEndpoint(
      {
        ...queryParams
      },
      [queryParams],
      {
        enabled: !!personDetails
      }
    )

  const statusOptions = Object.values(AnsweredState).map((item) => ({
    label: t(`questionnaires.${item}`),
    value: item
  }))

  const options = [defaultSortingOption, ...statusOptions]

  const onSearch = (val: string) => {
    setSearch(val)
    resetPagination(pagination)
  }

  const onSelect = (val: AnsweredState) => {
    setStatus(val)
    resetPagination(pagination)
  }

  return (
    <Flex vertical>
      <Flex justify="space-between">
        <SearchBar
          onSearch={onSearch}
          placeholder={t('questionnaires.search_by_title')}
        />

        <Flex gap={8}>
          <Select
            options={options}
            onChange={(val: AnsweredState) => onSelect(val)}
          />
        </Flex>
      </Flex>

      <Divider />

      <Table
        bordered
        rowKey="id"
        columns={columns}
        scroll={{ x: 'max-content' }}
        loading={isLoading || isPersonLoading}
        dataSource={data?.data}
        pagination={{
          ...pagination,
          total: data?.totalCount
        }}
      />
    </Flex>
  )
}
